interface ConditionalWrapper {
  condition: boolean
  wrapper: (c: JSX.Element) => JSX.Element
  children: JSX.Element
}

const ConditionalWrapper = ({ condition, wrapper, children }: ConditionalWrapper) =>
  condition ? wrapper(children) : children

export default ConditionalWrapper
